import React, { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../redux/user/actions.user';
import * as analyticsActions from '../../../redux/analytics/actions.analytics';
import MainHeader from '../../headers/MainHeader/MainHeader';
import PlanTile from './PlanTile';
import asyncDispatch from '../../../services/mini/asyncDispatch';
import { Loader } from '../../components/Loader/Loader';
import { pages, actions as planActions } from '../../../const/plansAnalytics';
import ReactTooltip from 'react-tooltip';
import PlansHeader from './PlansHeader';


function PlansPage({
    plans,
    planId,
    getPlans,
    showChangePlanPopup,
    trackPlanAction,
    githubLogin,
    numOfStars,
    params
}) {

    useEffect(() => {
        getPlans().then(() => {
            ReactTooltip.rebuild();
        }, () => { });
        trackPlanAction({ page: pages.plans, action: planActions.openPage });
    }, [getPlans, trackPlanAction]);

    const onContactSales = useCallback((nextPlan) => {
        trackPlanAction({ page: pages.plans, action: planActions.contactSales });
    }, [trackPlanAction]);


    const onChangePlan = useCallback((nextPlan) => {
        showChangePlanPopup({
            nextPlan
        });
    }, [showChangePlanPopup]);

    const filteredPlans = plans?.filter(plan => {
        if (plan.isUserSpecificPlan) {
            return true;
        }
        return plan.isPublic && !plan.isEnterprise;
    }) || [];

    return (
        <div className="plans-page">
            <MainHeader>
                <PlansHeader />
            </MainHeader>
            <div className="plans-page__content-wrapper">
                <div className="plans-page__content">
                    <div className="plans-page__internal-content">
                        <div className="plans-page__title">Alan pricing plans</div>
                        <div className="plans-page__subtitle">Choose a plan that works best for you</div>
                        <div className="plans-page__plans">
                            {(plans?.length > 0) ?
                                <>
                                    {filteredPlans.length > 0 ?
                                        filteredPlans
                                            .map((plan, index) => {
                                                return <PlanTile
                                                    key={index}
                                                    plan={plan}
                                                    plansCount={plans?.length}
                                                    currentPlanId={planId}
                                                    onContactSales={onContactSales}
                                                    onChangePlan={onChangePlan}
                                                    inPlans={true} />;
                                            }) :
                                        <div className="plans-page__no-plans">
                                            We were not able to find plans for you. <br />Refresh the page later or contact <a href="mailto:support@alan.app"
                                                target="_blank" rel="noreferrer">
                                                support
                                            </a> for additional details.
                                        </div>
                                    }
                                </>
                                :
                                <div className="plans-page__plans-loader">
                                    <Loader theme="light" size="big" />
                                </div>}
                        </div>
                        <ReactTooltip id="planTooltip" place="top" effect="solid" class="tutor-dark-tooltip plan-tooltip" />
                    </div>
                </div>
            </div>
        </div>
    );
}

function mapStateToProps({ user }, ownProps) {
    return {
        plans: user.plans,
        planId: user.planId,
        balance: user.balance,
        paidUntilTs: user.paidUntilTs,
        currentPlan: user.currentPlan,
        billingStatus: user.billingStatus,
        githubLogin: user.githubLogin,
        numOfStars: user.numOfStars,
        freeInteractions: user.freeInteractions,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getPlans: (param) => asyncDispatch(actions.getPlans, dispatch, param),
        showChangePlanPopup: (param) => asyncDispatch(actions.showChangePlanPopup, dispatch, param),
        trackPlanAction: (param) => asyncDispatch(analyticsActions.trackPlanAction, dispatch, param),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PlansPage);
